import {SYSTEMSETTING} from 'Constants/ActionTypes';

const actions={
  getUserList(data){
    return {
      type: SYSTEMSETTING.POST_USER_LIST,
      payload: {
        request: {
          method: 'post',
          url: `/robot/application/userList`,
          data,
        },
      },
    };
  },
  getSelect(id){
    return {
      type: SYSTEMSETTING.GET_USER_ROLE_SELECT,
      payload: {
        request: {
          method: 'get',
          url: `/robot/application/role/select/${id}`,
        },
      },
    };
  },
  addRoles(userId,roleId){
    return {
      type: SYSTEMSETTING.POST_USER_ROLEBINDING,
      payload: {
        request: {
          method: 'post',
          url: `/robot/permit/roleBinding/${userId}`,
          data:{roleId}
        },
      },
    };
  }
}
export default actions;